// ============================================================
// types/periodo.types.ts
// ============================================================

// ── Payload exacto → POST /periodos  y  PUT /periodos/{id} ──
export interface PeriodoPayload {
  anioEscolarId: number;
  numero:        number;
  nombre:        string;
  fechaInicio:   string;   // yyyy-MM-dd
  fechaFin:      string;   // yyyy-MM-dd
  tipo?:         'REGULAR' | 'RECUPERACION';
}

// ── Response del backend ─────────────────────────────────────
export interface PeriodoResponse {
  idPeriodo:     number;
  anioEscolarId: number;
  anio:          number;
  numero:        number;
  nombre:        string;
  fechaInicio:   string;
  fechaFin:      string;
  activo:        boolean;
  tipo:          'REGULAR' | 'RECUPERACION';
}

// ── Estado interno del formulario ────────────────────────────
export interface PeriodoFormState {
  anioEscolarId: string;
  numero:        string;
  nombre:        string;
  fechaInicio:   string;
  fechaFin:      string;
}

export const PERIODO_FORM_INITIAL: PeriodoFormState = {
  anioEscolarId: '',
  numero:        '',
  nombre:        '',
  fechaInicio:   '',
  fechaFin:      '',
};
